/**
 * Allen-Bradley Scripts.
 *
 * Allen-Bradley related scripts to be executed globally.
 *
 * @author Alvin Yau.
 */

/**
 * Replace text based on pattern
 * @param element
 * @param pattern
 * @param replacement
 */
export function replaceInText(element, pattern, replacement) {
    for (let node of element.childNodes) { // eslint-disable-line
        switch (node.nodeType) {
        case Node.ELEMENT_NODE:
            replaceInText(node, pattern, replacement);
            break;
        case Node.TEXT_NODE:
            node.textContent = node.textContent.replace(pattern, replacement);
            break;
        case Node.DOCUMENT_NODE:
            replaceInText(node, pattern, replacement);
            break;
        default:
            break;
        }
    }
}

// Replace regular dash with non-break line character dash to prevent the brand name from breaking into new line
replaceInText(document.body, /Allen-Bradley/g, 'Allen‑Bradley');
